export default __webpack_public_path__ + "static/media/maggie.07870756.png";